import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useFa, useLoad, rp, Pill, Table, Pager, inputCls, Sel } from "./kit";
import { RequestForm } from "./RequestForm";
import { RequestDetail } from "./RequestDetail";

const STATUSES = ["Submitted", "Accounts Verified", "Awaiting Approval", "Approved", "Payment Initiated", "Paid", "Rejected", "Cancelled"];

export function RequestList({ kinds, newKind, title, testid }) {
  const me = useFa();
  const [sp, setSp] = useSearchParams();
  const [status, setStatus] = useState("");
  const [q, setQ] = useState("");
  const [skip, setSkip] = useState(0);
  const [open, setOpen] = useState(false);
  const [data, reload] = useLoad(`/fa/requests?kind=${kinds}&status=${status}&q=${encodeURIComponent(q)}&skip=${skip}`);
  const sel = sp.get("request");
  const cols = [
    { k: "number", l: "Request" }, { k: "kind_label", l: "Type" }, { k: "party_name", l: "Employee / vendor" }, { k: "project_name", l: "Project" },
    { k: "amount", l: "Amount", right: true, r: (x) => rp(x.amount_paise) }, { k: "paid", l: "Paid", right: true, r: (x) => rp(x.paid_paise) },
    ...(kinds.includes("advance") ? [{ k: "unused", l: "Unused", right: true, r: (x) => (x.kind.endsWith("advance") ? rp(x.unused_paise) : "—") }] : []),
    { k: "status", l: "Status", r: (x) => <Pill v={x.status} /> }, { k: "pending_on", l: "Pending with" }, { k: "created_at", l: "Raised", r: (x) => x.created_at.slice(0, 10) },
  ];
  return (
    <div className="space-y-4" data-testid={testid}>
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div><h2 className="text-lg font-extrabold text-zinc-900">{title}</h2>{!me.finance && <p className="text-xs text-zinc-500">Showing your own requests{me.leads.length ? " and requests on projects you lead" : ""}.</p>}</div>
        <div className="flex flex-wrap gap-2">
          <input data-testid={`${testid}-search`} placeholder="Search number, party, project" className={`${inputCls} w-56`} value={q} onChange={(e) => { setQ(e.target.value); setSkip(0); }} />
          <div className="w-44"><Sel testid={`${testid}-status`} value={status} onChange={(v) => { setStatus(v); setSkip(0); }} options={STATUSES} placeholder="All statuses" /></div>
          {newKind && <Button data-testid={`${testid}-new`} onClick={() => setOpen(true)}><Plus className="mr-1 h-4 w-4" />New request</Button>}
        </div>
      </div>
      <Table testid={`${testid}-table`} cols={cols} rows={data?.items || []} onRow={(x) => setSp({ request: x.id })} />
      <Pager total={data?.total || 0} skip={skip} setSkip={setSkip} testid={`${testid}-pager`} />
      <RequestForm open={open} onOpenChange={setOpen} kind={newKind} onSaved={(d) => { reload(); setSp({ request: d.id }); }} />
      <RequestDetail id={sel} onClose={() => setSp({})} onChanged={reload} />
    </div>
  );
}
